<template>
  <div>
    <van-popup v-model="showpop" mode="center" :close-on-click-overlay="false" :round="true">
      <div class="popup-content">
        <div class="popup-top">
          <div class="title">积分获取规则</div>
          <div class="con"><span>浇水：</span>每人每天浇水1次可获得1积分；</div>
          <div class="con"><span>随手报：</span>随手报提交后，每人每天的第一条可获得1积分；</div>
          <div class="con"><span>村民圈社区圈：</span>发布审核通过后，每人每天的第一条可获得1积分；</div>
          <button class="btn" @click="clickClose">我知道了</button>
        </div>
        <img class="close-jfgz" src="@images/close.png" @click="clickClose" />
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showpop: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.showpop = this.value
      },
    },
  },
  created() {},
  methods: {
    clickClose() {
      this.$emit('input', false)
    },
  },
}
</script>

<style lang="less" scoped>
.popup-content {
  width: 290px;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .popup-top {
    width: 290px;
    height: 396px;
    background: url('~@images/gzfw/bg-jfgz.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 132px 24px 0;

    .title {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      text-align: center;
      margin-bottom: 18px;
    }

    .con {
      color: #333333;
      font-size: 14px;
      line-height: 24px;
      span {
        color: #2593e1;
        font-weight: 500;
      }
    }

    .btn {
      width: 100%;
      height: 40px;
      background-image: linear-gradient(90deg, #42a9f2 0%, #2593e1 100%);
      border-radius: 20px;
      border: none;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      margin-top: 20px;
      text-align: center;
      line-height: 40px;
    }
  }

  .close-jfgz {
    width: 29px;
    height: 29px;
    margin-top: 35px;
  }
}

/deep/ .van-popup {
  background-color: transparent;
}
</style>
